"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieConsentSettingsParser = void 0;
const cookieConsentSettingsParser = (cookieConsentSetting) => {
    return cookieConsentSetting.split('|').reduce((previousValue, currentValue) => {
        const cookieConsentSettingItem = currentValue.split(':');
        if (cookieConsentSettingItem.length === 2) {
            const cookieConsentSettingKey = cookieConsentSettingItem[0];
            const cookieConsentSettingToggleValue = cookieConsentSettingItem[1] === '1';
            return Object.assign(Object.assign({}, previousValue), { [cookieConsentSettingKey]: cookieConsentSettingToggleValue });
        }
        return previousValue;
    }, {});
};
exports.cookieConsentSettingsParser = cookieConsentSettingsParser;
//# sourceMappingURL=cookieConsent.util.js.map